import { add, addHours, sub } from "date-fns";
import { definitions } from "../../api/supabase/client";
import { EventInput, EventSourceInput } from "@fullcalendar/react";
import { Class } from "../../api/class";
import { addDays } from "date-fns";
import cronParser from "cron-parser";

const logger = console;

export const DAY_TO_NUMBER_DATE_FNS = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 0,
} as const;

export const DAY_TO_NUMBER = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 7,
} as const;

export const NUMBER_TO_DAY = {
  1: "MONDAY",
  2: "TUESDAY",
  3: "WEDNESDAY",
  4: "THURSDAY",
  5: "FRIDAY",
  6: "SATURDAY",
  7: "SUNDAY",
} as const;

export interface ClassTiming extends EventInput {
  groupId: string;
  classID: number;
  timeSlotID: number;
  timeSlot: Partial<definitions["TimeSlot"]>;
  class: Class;
  start: Date;
  end: Date;
}

export const dateToMonthDayString = (date: Date): string => {
  const options = { year: "numeric", month: "short", day: "numeric" } as const;
  return date.toLocaleDateString("en-US", options);
};

export const dateToDateTimeString = (date: Date): string => {
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  } as const;
  return date.toLocaleDateString("en-US", options);
};

export const getClassTimings = (
  curClass: Class,
  timeSlot: Partial<definitions["TimeSlot"]>
): ClassTiming[] => {
  const events: ClassTiming[] = [];
  const cronExpression = timeSlot.cronMinHrDay;
  if (!curClass.class.startDate || !curClass.class.endDate) {
    throw new Error("Missing class start or end date!");
  }
  if (!cronExpression) {
    throw new Error("Missing cron expression");
  }
  if (curClass.class.id === undefined) {
    throw new Error("Missing class ID!");
  }
  if (timeSlot.id === undefined) {
    throw new Error("Missing timeslot ID!");
  }
  const startDate = new Date(curClass.class.startDate);
  const endDate = new Date(curClass.class.endDate);

  const interval = cronParser.parseExpression(cronExpression, {
    currentDate: startDate,
    endDate: addDays(endDate, 1),
    tz: "Asia/Singapore",
  });

  while (true) {
    try {
      const nextDate = interval.next().toDate();

      events.push({
        title: `Class ${curClass.class.id} : Level ${curClass.level.hskDifficulty}`,
        groupId: String(curClass.class.id!) + String(timeSlot.id),
        start: nextDate,
        end: addHours(nextDate, 1),
        classID: curClass.class.id,
        timeSlotID: timeSlot.id,
        timeSlot,
        class: curClass,
      });
    } catch (e) {
      break;
    }
  }

  return events;
};

export const getTimezoneOffsetString = (): string => {
  const currentDate = new Date();
  const timeZoneOffset = currentDate.getTimezoneOffset();

  // Convert the offset to hours and minutes
  const hours = Math.abs(Math.floor(timeZoneOffset / 60));
  const minutes = Math.abs(timeZoneOffset % 60);

  // Determine the sign of the offset
  const sign = timeZoneOffset > 0 ? "-" : "+";

  // Format the offset in GMT format
  const gmtOffset = `GMT${sign}${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;

  return gmtOffset; // Example output: GMT+03:00
};

export const getTimezoneRegionString = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone; //Example output: Asia/Singapore
};

export type EngagementPanelResultString = "A" | "B" | "C" | "D" | undefined;

type EngagementPanelResults = {
  [id: number]: EngagementPanelResultString;
};

// const trial: EngagementPanelResults = {
//   "15": "A",
// }

export interface HMSTalkingPartySessionStore {
  currentEngagementPanel?: number;
  showAnswerForEngagementPanel?: boolean;
  currentModule?: {
    module: string;
    topic: string;
    level: string;
    moduleID?: number;
  };
}

export interface HMSTalkingPartyPeerMetadata {
  engagementPanelResults?: EngagementPanelResults;
  isHandRaised?: boolean;
  feeling?: string;
}

//for tel input stuff
export function getMinTelNumberString(
  intlTelInputInstance: intlTelInput.Plugin | undefined,
  currentNumber: string | undefined
) {
  if (!intlTelInputInstance) return currentNumber ?? "+65 ";

  const countryDialCodeFrontPadding = `+${
    intlTelInputInstance.getSelectedCountryData().dialCode
  } `;

  console.log(countryDialCodeFrontPadding);
  if (!currentNumber) {
    console.log("fullNumber not available.");
    return countryDialCodeFrontPadding;
  }

  if (currentNumber.length <= countryDialCodeFrontPadding.length) {
    console.log(
      "fullNumber lower than padding, displaying padding:",
      countryDialCodeFrontPadding
    );
    return countryDialCodeFrontPadding;
  }

  return currentNumber;
}
